import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import HeaderPublico from "../../components/HeaderPublico";
import FooterPublico from "../../components/FooterPublico";
import CarruselCursos from "../../components/CarruselCursos";
import { API_URL } from "../../config";
import usePublicSiteTexts from "../../hooks/usePublicSiteTexts";
import useGlobalTestimonials from "../../hooks/useGlobalTestimonials";
import "./PaginaPublicitaria.css";

function PaginaPublicitaria() {
  const [cursos, setCursos] = useState([]);
  const navigate = useNavigate();
  const { texts } = usePublicSiteTexts();
  const { testimonials, loading: loadingTestimonials } = useGlobalTestimonials();


// 1) Carga y normaliza la respuesta
  useEffect(() => {
  fetch(`${API_URL}/cursos-publicos`)
    .then(res => {
      if (!res.ok) throw new Error(`Status: ${res.status}`);
      const contentType = res.headers.get("content-type");
      if (!contentType || !contentType.includes("application/json")) {
        throw new Error("Respuesta no es JSON");
      }
      return res.json();
    })
    .then(data => {
      // Normaliza siempre a un array
      const lista = Array.isArray(data)
        ? data
        : Array.isArray(data.cursos)
          ? data.cursos
          : [];
      setCursos(lista);
    })
    .catch(err => {
      console.error("Error al cargar cursos:", err);
      setCursos([]);  // fallback vacío
    });
}, []);


// 2) Scroll arriba al montar
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

// Elimina duplicados  
  const cursosUnicos = [...new Map(cursos.map(c => [c._id, c])).values()];
  
return (
  <div className="pagina-publicitaria">
    <HeaderPublico cursos={cursosUnicos} />

    {/* ===========================
        HERO PRINCIPAL
       =========================== */}
    <section 
      className="banner-publico" 
      style={{ backgroundImage: 'url(/imagenes/imagen1.jpg)' }}
    >
      <h1>{texts.heroTitle}</h1>
      <p>{texts.heroSubtitle}</p>
    </section>

    {/* ===========================
        SECCIÓN: QUÉ OFRECEMOS (NUEVO)
       =========================== */}
    <section className="bloque-beneficios">
      <h2>{texts.benefitsTitle}</h2>

      <div className="beneficios-grid">
        <div className="beneficio-item">
          <h3>{texts.benefit1Title}</h3><br></br>
          <p>{texts.benefit1Description}</p>
        </div>

        <div className="beneficio-item">
          <h3>{texts.benefit2Title}</h3><br></br>
          <p>{texts.benefit2Description}</p>
        </div>

        <div className="beneficio-item">
          <h3>{texts.benefit3Title}</h3><br></br>
          <p>{texts.benefit3Description}</p>
        </div>

        <div className="beneficio-item">
          <h3>{texts.benefit4Title}</h3><br></br>
          <p>{texts.benefit4Description}</p>
        </div>
      </div>
    </section>

    {/* ===========================
        SECCIÓN CURSOS
       =========================== */}
    <section className="cursos-publicos">
      <div className="cursos-publicos-header">
        <h2>{texts.coursesSectionTitle}</h2>
        <button type="button" className="cursos-ver-todos-btn" onClick={() => navigate("/cursos")}>
          {texts.coursesCtaLabel}
        </button>
      </div>

      <CarruselCursos cursos={cursosUnicos} />

      {/* ===========================
          SECCIÓN EXPLICATIVA EXTRA (MEJORADA)
         =========================== */}
      <div className="contenedor2">
        <h1>{texts.learningTitle}</h1>
        <p>{texts.learningDescription}</p>

        <p className="p1">
          <b>{texts.learningHighlight}</b>
        </p>
      </div>
    </section>


    <section className="como-funciona">
  <h2>{texts.howItWorksTitle}</h2><br></br><br></br>

  <div className="pasos-grid">
    <div className="paso">
      <span>1</span>
      <h3>{texts.step1Title}</h3><br></br>
      <p>{texts.step1Description}</p>
    </div>

    <div className="paso">
      <span>2</span>
      <h3>{texts.step2Title}</h3>
      <p>{texts.step2Description}</p>
    </div>

    <div className="paso">
      <span>3</span>
      <h3>{texts.step3Title}</h3>
      <p>{texts.step3Description}</p>
    </div>

    <div className="paso">
      <span>4</span>
      <h3>{texts.step4Title}</h3>
      <p>{texts.step4Description}</p>
    </div>
  </div>
</section>


    {/* ===========================
        NUEVA SECCIÓN: TESTIMONIOS
       =========================== */}
    <section className="testimonios">
      <h2>{texts.testimonialsTitle}</h2>
      {loadingTestimonials ? (
        <p className="testimonios-loading">Cargando testimonios…</p>
      ) : testimonials.length === 0 ? (
        <div className="testimonios-grid">
          <div className="testimonio-item">
            <p>"{texts.testimonialsFallbackText}"</p>
            <span>– {texts.testimonialsFallbackAuthor}</span>
          </div>
        </div>
      ) : (
        <div className="testimonios-grid">
          {testimonials.map((testimonio) => (
            <div key={testimonio._id} className="testimonio-item">
              <p>"{testimonio.text}"</p>
              <span>– {testimonio.author}</span>
            </div>
          ))}
        </div>
      )}
    </section>

    {/* ===========================
        SECCIÓN FINAL MOTIVACIONAL
       =========================== */}
    <section className="cta-final">
      <h2>{texts.ctaTitle}</h2>
      <p>{texts.ctaSubtitle}</p>

      <button className="cta-boton" onClick={() => navigate("/login")}>
        {texts.ctaButtonLabel}
      </button>
    </section>

    <FooterPublico />
  </div>
);

}

export default PaginaPublicitaria;
